import { call, put } from 'redux-saga/effects'

import { fetchProjectAttachments } from '@/services/project'
import type { AttachmentItem } from '@/types'
import { InternalStorageActions, type StorageActions } from '../actions'

export function* setAttachments({
  payload: { id },
}: ReturnType<typeof StorageActions.setAttachments>) {
  try {
    const projectAttachmentsResponse: AttachmentItem[] = yield call(
      fetchProjectAttachments,
      id
    )

    const payload = projectAttachmentsResponse || []

    const internalAction = InternalStorageActions.setAttachments(payload)

    yield put(internalAction)
  } catch (error) {
    // фоновое обновление списка вложений — не повод показывать юзеру тост
    console.error(error)
  }
}
